import { render, staticRenderFns } from "./ImageResponsive.vue?vue&type=template&id=3bb9d806&"
import script from "./ImageResponsive.vue?vue&type=script&lang=js&"
export * from "./ImageResponsive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports